import React from "react";
import { observer } from "mobx-react";
import { WeaDialog } from "ecCom";
import MessageCenter from "../message-center/index";
import { Popover } from "antd";
import * as API from "../../apis/index";
import WeaMessageCenterStore from "../../stores/index";
import WeaLocaleProvider from "../../../../ecology9/wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

@observer
class ContentItem extends React.PureComponent {
  onClick = () => this.props.onClick(this.props.item);
  render() {
    const { item } = this.props;
    return (
      <div onClick={this.onClick} className="item wea-f12">
        <i className={"icon"}>
          <img alt="" src={item.icon} />
        </i>
        <span className="item-text">{item.name}</span>
        <span className="icon-red">
          {Number(item.count) > 99 ? "99" : item.count}
        </span>
      </div>
    );
  }
}

@observer
export default class DialogComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      count: 0,
      popVisiable: false,
      popList: [],
      popIndex: 0,
      popItem: null,
      popEnter: false
    };
    this.timer = null;
    window._message_center = {};
  }

  componentDidMount() {
    this.startMsgCount();
    this.getMsgTypeNumberList();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.intervalTime !== this.props.intervalTime) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getMsgCount();
      }, nextProps.intervalTime);
    }
  }

  startMsgCount() {
    this.getMsgCount();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.getMsgCount();
    }, this.props.intervalTime);
  }

  getMsgTypeNumberList() {
    API.getMsgTypeNumberList({
      number: this.state.count
    }).then(res => {
      if (res.item && res.item.length > 0) {
        const newArray = [];
        res.item.forEach(item => {
          if (Number(item.count) > 0) {
            newArray.unshift(item);
          } else {
            newArray.push(item);
          }
        });
        this.setState({
          popList: newArray
        });
      }
    });
  }

  getMsgCount(params, cb) {
    API.getMsgCount(params).then(res => {
      let count = 0;
      if (res && res.count > 0) {
        if (res.count > 99) {
          count = "99+";
        } else {
          count = res.count;
        }
      }
      this.setState({ count });
      if (cb && typeof cb === "function") {
        cb(count);
      }
    });
  }

  closeDialog = () => {
    window._message_center = { open: false };
    // $(`#pop-close-${this.props.id}`).show();
    this.setState({
      visible: false
    });
    this.startMsgCount();
  };

  smallBellClick = () => {
    $(`#pop-close-${this.props.id}`).hide();
    if (parseInt(this.state.count) > 0) {
      clearInterval(this.timer);
    }
    window._message_center = { open: true };
    this.setState({
      visible: true,
      popItem: null,
      popIndex: 0,
      popVisiable: false
    });
  };

  popUpBellMask = () => {
    this.getMsgCount({}, count => {
      if (parseInt(count) > 0) {
        if (!window._message_center.open) {
          this.setState({ popVisiable: true });
        }
        const numDom = $(
          `#dialogMode-message-center-${this.props.id} .right-corner-num`
        );
        numDom.show();
        this.getMsgTypeNumberList();
      } else {
        this.setState({ popVisiable: false });
      }
    });
  };

  checkMore = (item = { id: 0 }) => {
    this.setState({
      popVisiable: false,
      visible: true,
      popIndex: item.id,
      popItem: item.id === 0 ? null : item
    });
  };

  onMouseEnter = () => {
    this.setState({
      popEnter: true
    });
  };

  onMouseLeave = () => {
    this.setState({ popVisiable: false, popEnter: false });
  };

  onCenterMouseLeave = () => {
    setTimeout(() => {
      if (!this.state.popEnter) {
        this.setState({ popVisiable: false });
      }
    }, 500);
  };

  onCancel = () => {
    this.setState({ visible: false });
  };

  renderPopContent() {
    return (
      <div
        className="wea-messageCenter-remind-popover-content"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {/* <div style={{ height: 55 }} /> */}
        <h3 className="title wea-f14">{getLabel("383606", "消息中心")}</h3>
        <div className="content-container">
          {this.state.popList.map(item => {
            if (item.count === 0) {
              return false;
            }
            return <ContentItem item={item} onClick={this.checkMore} />;
          })}
        </div>
        <div className="button-more wea-f12" onClick={this.checkMore}>
          {getLabel("81408", "查看更多")}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        {...this.props}
        id={`dialogMode-message-center-${this.props.id}`}
        onClick={this.smallBellClick}
        onMouseEnter={this.popUpBellMask}
        onMouseLeave={this.onCenterMouseLeave}
      >
        {/* {this.props.children} */}
        <Popover
          placement="leftBottom"
          visible={this.state.popVisiable}
          content={this.renderPopContent()}
          overlayClassName="wea-messageCenter-remind-popover"
        >
          {this.props.icon ? (
            <span className="small-bell-pos">
              {this.props.icon}
              <i
                style={
                  parseInt(this.state.count) > 0
                    ? { display: "block", ...this.props.rightCornerStyle }
                    : { display: "none" }
                }
                className={"right-corner-num"}
              >
                {this.state.count}
              </i>
            </span>
          ) : (
            <span
              style={{ ...this.props.iconStyle }}
              className={`${
                this.props.iconClass
                  ? this.props.iconClass
                  : "wea-messageCenter-remind"
              } small-bell-pos`}
            >
              <i
                style={
                  parseInt(this.state.count) > 0
                    ? { display: "block" }
                    : { display: "none" }
                }
                className={`right-corner-num ${
                  this.state.count > 0 ? "" : "more99"
                }`}
              >
                {this.state.count}
              </i>
            </span>
          )}
        </Popover>
        <WeaDialog
          className="coms-message-center"
          maskClosable={true}
          title={getLabel("383606", "消息中心")}
          style={{ width: 900 }}
          iconBgcolor="#0079de"
          icon="wea-messageCenter-remind weaTop-remind"
          visible={this.state.visible}
          onCancel={this.onCancel}
        >
          <MessageCenter
            {...this.props}
            visible={this.state.visible}
            count={this.state.count}
            systemSetStore={WeaMessageCenterStore}
            closeDialog={this.closeDialog}
            getMsgCount={this.getMsgCount.bind(this)}
            popIndex={this.state.popIndex}
            popItem={this.state.popItem}
          />
        </WeaDialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/dialogMode/index.js